import { isValidDateString } from '../../../helpers/date';
import { SearchableOption } from '../../../types';
import {
    HumanCapabilitySkill,
    HumanCapabilitySkillResource,
    KnowledgeAreaSkill,
    KnowledgeAreaSkillResource,
    Skill,
    SkillBase,
    SkillBaseResource,
    SkillResource,
    SkillType,
} from './Skills';

export const transformToSkillBase = (resource: SkillBaseResource): SkillBase => {
    const generatedAtTimeDate = resource.generatedAtTime && isValidDateString(resource.generatedAtTime)
        ? new Date(resource.generatedAtTime)
        : undefined;

    return {
        id: resource.id,
        type: resource.type,
        label: resource.prefLabel,
        generatedAtTime: generatedAtTimeDate,
    };
};

export const transformToHumanCapabilitySkill = (resource: HumanCapabilitySkillResource): HumanCapabilitySkill => {
    const skillBase = transformToSkillBase(resource);

    return {
        ...skillBase,
        definition: resource.definition,
        altLabels: resource.altLabels,
        includesScope: resource.includesScope,
        excludesScope: resource.excludesScope,
    };
};

export const transformToKnowledgeAreaSkill = (resource: KnowledgeAreaSkillResource): KnowledgeAreaSkill => {
    const skillBase = transformToSkillBase(resource);

    return {
        ...skillBase,
        definition: resource.definition,
        broadMatch: resource.broadMatch,
    };
};

export const transformToSkill = (resource: SkillResource): Skill | undefined => {
    if (resource.type === SkillType.humanCapability) {
        return transformToHumanCapabilitySkill(resource);
    }

    if (resource.type === SkillType.knowledgeArea) {
        return transformToKnowledgeAreaSkill(resource);
    }

    return undefined;
};

export const transformSkillBaseToSearchableOption = (skillBase: SkillBase): SearchableOption => ({
    value: skillBase.id,
    label: skillBase.label,
});
